export default __webpack_public_path__ + "static/media/hero.2098813b.jpg";